import React, { useEffect, useRef, useState } from "react";
import { Container } from "@material-ui/core";

import ProjectsEdit from "./ProjectsEdit";
import ProjectsOverview from "./ProjectsOverview";
import SubscriptionNotice from "./SubscriptionNotice";
import { useRouteMatch } from "react-router-dom";
import { TAB_IDS } from "../../../data/constants";

const PageProjects = props => {
  const {
    saveDisabled,
    setSaveDisabled,
    expired,
    incompleteAccount,
    incompletePayment,
    failedToProcess,
    failedToProcessTrial,
    setAccountDrawerOpen
  } = props;

  // General
  const inProjects = useRouteMatch("/projects");

  // States
  const [projectsRef, setProjectsRef] = useState([]);
  const [currentAction, setCurrentAction] = useState("overview");
  const [currentProject, setCurrentProject] = useState(null);
  const [duplicateSaved, setDuplicateSaved] = useState(false);
  const [duplicateId, setDuplicateId] = useState(null);
  const [hasAnyProject, setHasAnyProject] = useState(false);
  const [reloadCurrentPage, setReloadCurrentPage] = useState(false);

  const [currentTabId, setCurrentTabId] = useState(TAB_IDS.UPCOMING);

  // Refs
  const isEditingDuplicate = useRef(false);

  useEffect(() => {
    if (!inProjects) {
      setCurrentAction("overview");
    }
  }, [inProjects]);

  useEffect(() => {
    sessionStorage.setItem("currentProject", "");
  }, []);

  return (
    <Container maxWidth="md" fixed>
      {(expired ||
        incompleteAccount ||
        incompletePayment ||
        failedToProcess ||
        failedToProcessTrial) && (
        <SubscriptionNotice
          expired={expired}
          failedToProcessTrial={failedToProcessTrial}
          failedToProcess={failedToProcess}
        />
      )}
      <ProjectsOverview
        duplicateId={duplicateId}
        duplicateSaved={duplicateSaved}
        setDuplicateId={setDuplicateId}
        setDuplicateSaved={setDuplicateSaved}
        projectsRef={projectsRef}
        setProjectsRef={setProjectsRef}
        currentTabId={currentTabId}
        setCurrentTabId={setCurrentTabId}
        hasAnyProject={hasAnyProject}
        setHasAnyProject={setHasAnyProject}
        setCurrentProject={setCurrentProject}
        currentAction={currentAction}
        setCurrentAction={setCurrentAction}
        isEditingDuplicate={isEditingDuplicate}
        expired={expired}
        incompleteAccount={incompleteAccount}
        incompletePayment={incompletePayment}
        failedToProcess={failedToProcess}
        failedToProcessTrial={failedToProcessTrial}
        setAccountDrawerOpen={setAccountDrawerOpen}
        reloadCurrentPage={reloadCurrentPage}
        setReloadCurrentPage={setReloadCurrentPage}
      />
      <ProjectsEdit
        saveDisabled={saveDisabled}
        setSaveDisabled={setSaveDisabled}
        open={currentAction !== "overview"}
        setHasAnyProject={setHasAnyProject}
        projectsRef={projectsRef}
        currentTabId={currentTabId}
        setCurrentTabId={setCurrentTabId}
        currentProject={currentProject}
        currentAction={currentAction}
        setCurrentAction={setCurrentAction}
        duplicateId={duplicateId}
        setDuplicateSaved={setDuplicateSaved}
        isEditingDuplicate={isEditingDuplicate}
        setReloadCurrentPage={setReloadCurrentPage}
      />
    </Container>
  );
};

export default PageProjects;
